<template>
    <b-modal
        v-model="modalShow"
        id="modal-expiry-reminder"
        :centered="true"
        hide-footer
    >
        <template #modal-header="{ close }">
            <img class="close" src="@/assets/img/close_red.png" @click="close()">
            <h6 class="sub-title"><span class="sub-title-modal">{{ $t('modals.modal-expiry-reminder.titulo') }}</span></h6>
        </template>
        <ul class="expiry-reminder-list pl-3">
            <li v-for="r in reminders" :key="'exp' + r.id">{{ reminderText(r) }}</li>
        </ul>
        <div class="text-center mt-3">
            <b-button @click="close" variant="primary">{{ $t('modals.modal-expiry-reminder.button-ok') }}</b-button>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: "modalExpiryReminder",
    data() {
        return {
            modalShow: false,
            reminders: []
        }
    },
    methods: {
        show(list) {
            this.reminders = list || [];
            if (this.reminders.length) {
                this.modalShow = true;
            }
        },
        close() {
            this.modalShow = false;
            this.$bvModal.hide('modal-expiry-reminder');
        },
        expiryRemaining(r) {
            let rem = (r.duration || 0) - (r.totalHoursSchedule || 0);
            return rem > 0 ? Math.round(rem * 100) / 100 : 0;
        },
        reminderText(r) {
            let en = this.$i18n.locale === 'en';
            let label = r.name ? ' (' + r.name + ')' : '';
            return en
                ? 'Your package' + label + ' expires on ' + r.strExpirationDate + ' and you still have ' + this.expiryRemaining(r) + ' unscheduled hour(s). Please schedule them before it expires.'
                : 'Tu paquete' + label + ' vence el ' + r.strExpirationDate + ' y aún tienes ' + this.expiryRemaining(r) + ' hora(s) sin agendar. Por favor agéndalas antes del vencimiento.';
        }
    }
}
</script>
